import logoFleetzip from "@/assets/logo-light.png";
import { useAuth } from "@/contexts/AuthContext";
import { UI } from "@/lib/labels";
import { KeyRound, LogOut } from "lucide-react";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { Button } from "./ui/button";

/** Casca autenticada: cabeçalho fixo com identidade, usuário e logout. */
export function AppLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="flex min-h-screen flex-col">
      <header className="sticky top-0 z-30 border-b border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/80">
        <div className="mx-auto flex h-14 w-full max-w-7xl items-center justify-between gap-4 px-4">
          <Link to="/" className="flex items-center gap-3">
            <img src={logoFleetzip} alt={UI.appName} className="h-7 w-auto" />
            <span className="hidden border-l border-border pl-3 text-sm font-medium text-muted-foreground sm:inline">
              {UI.appTagline}
            </span>
          </Link>
          <div className="flex items-center gap-3">
            {user?.role === "admin" ? (
              <Link
                to="/tokens"
                className="inline-flex h-8 items-center gap-1.5 rounded-md px-3 text-sm font-medium text-foreground transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              >
                <KeyRound className="h-4 w-4" aria-hidden="true" />
                <span className="hidden sm:inline">{UI.tokens.navLabel}</span>
              </Link>
            ) : null}
            {user ? (
              <span className="hidden text-sm text-muted-foreground sm:inline">{user.name}</span>
            ) : null}
            <Button variant="ghost" size="sm" onClick={handleLogout}>
              <LogOut className="h-4 w-4" aria-hidden="true" />
              {UI.actions.logout}
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
